import { render } from "./ProposalDateItem.vue?vue&type=template&id=0239ed67&scoped=true&ts=true"
import script from "./ProposalDateItem.vue?vue&type=script&lang=ts"
export * from "./ProposalDateItem.vue?vue&type=script&lang=ts"

import "./ProposalDateItem.vue?vue&type=style&index=0&id=0239ed67&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0239ed67"]])

export default __exports__